import {GCP_TITLE} from './google-cloud-platform';
import {
  BIG_DATA, CDAP, DEVOPS_SERVICES, GC_DATA_FUSION, GC_MIGRATION, IOT_DEVELOPMENT, SOFTWARE_DEVELOPMENT, SYSTEM_SUPPORT
} from './services-names';

export const SERVICES_MENU = [
  {
    link: '/services/custom-software-development',
    text: SOFTWARE_DEVELOPMENT
  },
  {
    link: '/services/migration-to-google-cloud',
    text: GC_MIGRATION
  },
  {
    link: '/services/cdap-support',
    text: CDAP
  },
  {
    link: '/services/google-cloud-data-fusion',
    text: GC_DATA_FUSION
  },
  {
    link: '/services/system-support',
    text: SYSTEM_SUPPORT
  }
];
export const EXPERTISE_MENU = [
  {
    link: '/expertise/big-data-analytics',
    text: BIG_DATA
  },
  {
    link: '/expertise/devops',
    text: DEVOPS_SERVICES
  },
  {
    link: '/expertise/iot-development',
    text: IOT_DEVELOPMENT
  },
  // TODO Uncomment when GCP page is ready
  /* {
    link: '/expertise/google-cloud-platform',
    text: GCP_TITLE
  } */
];
